
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import Breakpoint from 'frontools/core/Breakpoint';
import ScrollUtils from 'frontools/utils/ScrollUtils';
import Context from 'frontools/core/Context';
import NumberUtils from 'frontools/utils/NumberUtils';
import DocumentUtils from 'frontools/utils/DocumentUtils';
import { autobind } from 'frontools/decorators/Autobind';

export default class AnimManager extends AbstractDispatcher {
    
    private _items                          : NodeList;
    private _animTimeout;
    private _animQueue                      : any[]                = [];
    private _lang                           : String               = Context.getInstance().language
    private _firstLoad                      : boolean              = true;

    constructor(private _foldOffset: number = 100) {
        super();

        this._items = document.querySelectorAll('[data-inview]');

        var resizeDebounce: any = DocumentUtils.debounce(this.onResize, 200);
        window.addEventListener('resize', resizeDebounce);

        window.addEventListener('scroll', this._onScrollFirst);

        window.onload = this._parseElements.bind(this); 
    };

    
    @autobind
    private _onScrollFirst(e: Event) {
        this._firstLoad = false;
        window.removeEventListener('scroll', this._onScrollFirst);
    };

    private _parseElements() {
        for (let i = 0, l = this._items.length; i < l; i++) {
            var ele = this._items[i] as HTMLElement;

            ScrollUtils.registerElement(ele, {
                offset: Context.getInstance().viewport.height - this._foldOffset,
                before: function(el) {}.bind(this),
                after: function(el) {
                    this._anim(el);
                }.bind(this)
            });

            ele.style.visibility = 'hidden';

            ScrollUtils.triggerEventOf(window);

            setTimeout(function() {
                ScrollUtils.triggerEventOf(window);
            }, 100);
        }
    }

    private _anim(ele: HTMLElement) {
        var type = ele.getAttribute('data-inview');

        // We make sure to unregister element from scroll listener
        ScrollUtils.removeRegistredElement(ele);

        // Prevents items above the fold from animation on page load
        if (this._firstLoad) {
            ele.style.visibility = 'visible';
            ele.setAttribute('data-inview', 'true');
            return;
        }
        
        // We make sure to never trigger the animation again
        //ele.removeAttribute('data-inview');
        ele.setAttribute('data-inview', 'true');
        var delayAttr = ele.getAttribute('data-inview-delay');
        var delay = delayAttr ? parseInt(delayAttr, 10) : 0;

        var i = 0;
        console.log(i)
        // var anim = function(i) {
            if (type === 'fromBottom') {
                TweenMax.from(ele, 1, {delay: delay + (i * .1), y: 50, alpha: 0, ease: Expo.easeOut, onComplete: this._clear, onCompleteParams: [ele]});

            } else if (type === 'fromLeft') {
                TweenMax.from(ele, 1, {delay: delay + (i * .1), x: -50, alpha: 0, ease: Expo.easeOut, onComplete: this._clear, onCompleteParams: [ele]});

            } else if (type === 'fromRight') {
                TweenMax.from(ele, 1, {delay: delay + (i * .1), x: 50, alpha: 0, ease: Expo.easeOut, onComplete: this._clear, onCompleteParams: [ele]});

            } else if (type === 'fade') {                    
                TweenMax.from(ele, 1, {delay: delay + (i * .1), alpha: 0, ease: Expo.easeOut, onComplete: this._clear, onCompleteParams: [ele]});

            } else if (type === '3dFromLeft') {
                TweenMax.set(ele, {backfaceVisibility: 'hidden', transformPerspective: 200, transformStyle: 'preserve-3d'});                    
                TweenMax.from(ele, 1, {delay: delay + (i * .1), rotationY: -180, ease: Expo.easeOut, onComplete: this._clear, onCompleteParams: [ele]});
            } else if (type === 'count') {
                var value = parseInt(ele.innerHTML, 10),
                    counter = {num: 0};

                TweenMax.to(counter, 3, {
                    num: value,
                    onUpdate: function() {
                        let val = NumberUtils.thousandSeparators(Math.ceil(counter.num), this._lang);
                        ele.innerText = String(val);
                    }.bind(this),
                    ease: Expo.easeOut,
                    onComplete: this._clear,
                    onCompleteParams: [ele]
                });
            }

            ele.style.visibility = 'visible';
        // }.bind(this);


        // this._animQueue.push(anim);
        // this._launchAnimation();
    };

    private _clear(ele: HTMLElement, props: string = 'x, y, opacity, visibility') {
        TweenMax.set(ele, {clearProps: props});
    };


    private _launchAnimation() {
        clearTimeout(this._animTimeout);
        this._animTimeout = setTimeout(function() {
            var i = 0;
            while (this._animQueue.length > 0) {                
                this._animQueue.shift().call(this, i);
                i++;
            }
        }.bind(this), 10);
    };

    
    @autobind
    private onResize() {
        for (let i = 0, l = this._items.length; i < l; i++) {
            var ele = this._items[i] as HTMLElement;
            ScrollUtils.registerElement(ele, {});
        }
    };

}